import { BaseService } from './BaseService.js';

/**
 * Calendar Service
 * Handles blocked dates and calendar operations using Laravel API
 */
export class CalendarService extends BaseService {
  constructor() {
    super('calendar'); // Laravel endpoint: /api/calendar
  }

  /**
   * Get blocked dates for date range
   */
  async getBlockedDates(startDate, endDate) {
    return this.customCall('blocked-dates', 'GET', {
      start_date: startDate,
      end_date: endDate
    });
  }

  /**
   * Create blocked date
   */
  async createBlockedDate(platformId, startDate, endDate, reason = null) {
    return this.customCall('blocked-dates', 'POST', {
      platform_id: platformId,
      start_date: startDate,
      end_date: endDate,
      reason
    });
  }

  /**
   * Remove blocked date
   */
  async removeBlockedDate(blockedDateId) {
    return this.customCall(`blocked-dates/${blockedDateId}`, 'DELETE');
  }

  /**
   * Get calendar events for month view
   */
  async getMonthEvents(year, month) {
    return this.customCall('events', 'GET', { year, month });
  }

  /**
   * Get availability calendar for platform
   */
  async getPlatformAvailability(platformId, startDate, endDate) {
    return this.customCall('availability', 'GET', {
      platform_id: platformId,
      start_date: startDate,
      end_date: endDate
    });
  }
}

// Export singleton instance for backward compatibility
const calendarService = new CalendarService();
export default calendarService; 